import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Form } from 'react-final-form'
import Cookies from 'universal-cookie'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import UpdatePasswordForm from './update-password-view'

import {
  updatePasswordRequest,
  updatePasswordRequestWithCode,
  newPasswordValidator,
  PASSWORD_REQUEST_EMAIL_COOKIE_NAME as EMAIL_COOKIE_NAME,
  VERIFICATION_CODE_COOKIE_NAME,
  PASSWORD_REQUEST_COOKIE_OPTIONS as COOKIE_OPTIONS
} from '@portal/kit/pkg/services'

import { FormButtons, Button, ContentBox } from '@portal/kit/pkg/components'
import { handleServerErrors } from '@portal/kit/pkg/helpers'
import ConfirmationItem from 'components/confirmation-item'

const cookies = new Cookies()

class UpdatePasswordContainer extends Component {
  state = {
    success: false,
  }

  getUpdatePasswordMethod = () => {
    return this.props.match.params.token === 'sms'
      ? this.updatePasswordWithCode
      : this.updatePasswordWithToken
  }

  updatePasswordWithToken = async values => {
    try {
      await updatePasswordRequest(
        values,
        this.props.match.params.token
      )
      this.setState({ success: true })
    }
    catch(e) {
      return handleServerErrors(e)
    }
  }

  updatePasswordWithCode = async values => {
    try {
      await updatePasswordRequestWithCode(
        values,
        cookies.get(EMAIL_COOKIE_NAME),
        cookies.get(VERIFICATION_CODE_COOKIE_NAME),
      )

      cookies.remove(EMAIL_COOKIE_NAME, COOKIE_OPTIONS)
      cookies.remove(VERIFICATION_CODE_COOKIE_NAME, COOKIE_OPTIONS)

      this.setState({ success: true })
    }
    catch(e) {
      return handleServerErrors(e)
    }
  }

  componentDidMount() {
    if (this.props.match.params.token === 'sms' && (!cookies.get(EMAIL_COOKIE_NAME) || !cookies.get(VERIFICATION_CODE_COOKIE_NAME))) {
      this.props.history.replace('/')
    }
  }

  render() {
    if (this.state.success) {
      return (
        <ContentBox title={this.props.t('portal.reset_password.confirmation_title')}>
          <ConfirmationItem>{this.props.t('portal.reset_password.confirmation_text')}</ConfirmationItem>
          <FormButtons>
            <Button to="/">{this.props.t('portal.reset_password.confirmation_button')}</Button>
          </FormButtons>
        </ContentBox>
      )
    }

    return (
      <Form
        onSubmit={this.getUpdatePasswordMethod()}
        validate={newPasswordValidator}
        render={formProps => <UpdatePasswordForm {...formProps}  />}
      />
    )
  }
}

UpdatePasswordContainer.propTypes = {
  fragment: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default compose(
  withRouter,
  withTranslation(),
)(UpdatePasswordContainer)
